module.exports = __webpack_public_path__ + "static/media/1-TransDefenseFund-Cover.c8f8e14c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/1-TransDefenseFund-Cover.jpg
// module id = 136
// module chunks = 0